/* eslint-disable no-useless-escape */
import React, {useContext} from 'react';
import InputMask from 'react-input-mask';
import { Field } from 'formik';
import { FormContext } from './FormContext';
import { appendValidationClassNames } from './utils';

const MaskedField = React.forwardRef((props, ref) => {
  const context = useContext(FormContext);
  const { disabled, readOnly } = context ? context : {};
  const extProps = { disabled, readOnly, ...props };  
  if(props.value){
    extProps.autoComplete="new-password";
  }
  let cleanRegExp;
  if (props.mask) {
    const maskSymbols = props.mask.replace(/[9,a,\*]*/g, '');
    const maskSymbolUnique = [];
    for (let index = 0; index < maskSymbols.length; index++) {
      const element = maskSymbols[index];
      if (maskSymbolUnique.indexOf(element) === -1) {
        maskSymbolUnique.push(element);
      }
    }

    if (maskSymbolUnique.length > 0) {
      var regStr = '[' + maskSymbolUnique.join(',') + ']*';
      cleanRegExp = new RegExp(regStr, 'gm');
    }
  }

  return (
    <Field
      {...props}
      ref={ref}
      render={({ field, form: { touched, errors, setFieldValue } }) => {
        const handleChange = event => {
          let value = event.target.value;
          if (!props.maskedValue && cleanRegExp) {
            if (value && typeof value === 'string') {
              value = value.replace(cleanRegExp, '');
            }
          }
            setFieldValue(props.name, value);
            if (props.onChange) props.onChange(event);
        };

        const classes = appendValidationClassNames(
          props.className,
          touched,
          errors,
          field.name
        );

        return (
          <InputMask
            {...field}
            {...extProps}
            maskChar={null}
            className={classes}
            onChange={handleChange}
          />
        );
      }}
    />
  );
});

MaskedField.displayName = 'MaskedField';

export default MaskedField;
